import { render, staticRenderFns } from "./ServiceAlertsModal.vue?vue&type=template&id=d3649796&scoped=true&"
import script from "./ServiceAlertsModal.vue?vue&type=script&lang=js&"
export * from "./ServiceAlertsModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAlertsModal.vue?vue&type=style&index=0&id=d3649796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3649796",
  null
  
)

export default component.exports